import { useCallback } from "react";
import AuthenticationService from "../../services/API/authenticationService";
import {
    LoginUserError,
    LoginUserRequest,
    LoginUserSuccess,
} from "../../services/reducers/authenticationReducer";
import { toast } from "react-toastify";
import { useAuthenticationContext } from "../../services/slices/AuthenticationSlicer";

const useAuthentication = () => {
    const { dispatch } =  useAuthenticationContext();
    const callSignInWithPhone = useCallback(
        async (credentials) => {
            try {
                const response = await AuthenticationService.signInWithPhone(credentials);
                if (response?.statusCode === 200) {
                    toast.success(response?.message);
                } 
                if (response?.statusCode === 422) {
                    toast.error(response?.message,{
                        autoClose: false, // Disables auto-close
                      });
                } 
                return response;
            } catch (error) {
                throw error.message;
            }
        },
        []
    );
    const callSignInWithPhoneVerify = useCallback(
        async (credentials) => {
            dispatch(LoginUserRequest());
            try {
                const response = await AuthenticationService.signInWithPhoneVerify(credentials);
                if (response?.statusCode === 200) {
                    // localStorage.setItem("userData", JSON.stringify(response.result));
                    dispatch(LoginUserSuccess(response));
                    // toast.success(response.message);
                }
                return response;
            } catch (error) {
                dispatch(LoginUserError(error.message));
                // toast.error(`${error.message}`);
                throw error.message;
            }
        },
        [dispatch]
    );

    const callSignInWithEmailLink = useCallback(
        async (credentials) => {
            try {
                const response = await AuthenticationService.signInWithEmailLink(credentials);
                if (response?.statusCode === 200) {
                    // toast.success(response?.message);
                } 

                return response;
            } catch (error) {
                throw error.message;
            }
        },
        []
    );

    const callSignInWithEmailLinkVerify = useCallback(
        async (credentials) => {
            dispatch(LoginUserRequest());
            try {
                const response = await AuthenticationService.signInWithEmailLinkVerify(credentials);
                if (response?.statusCode === 200) {
                    // localStorage.setItem("userData", JSON.stringify(response.result));
                    dispatch(LoginUserSuccess(response));
                    // toast.success(response.message);
                }
                return response;
            } catch (error) {
                dispatch(LoginUserError(error.message));
                // toast.error(`${error.message}`);
                throw error.message;
            }
        },
        [dispatch]
    );

    return {
        dispatchSignInWithPhone: callSignInWithPhone,
        dispatchSignInWithPhoneVerify: callSignInWithPhoneVerify,
        dispatchResendcode: callSignInWithPhone,
        dispatchSignInWithEmailLink: callSignInWithEmailLink,
        dispatchSignInWithEmailLinkVerify: callSignInWithEmailLinkVerify,
    };
};

export default useAuthentication;
